export default "__VITE_ASSET__47650530__"